//  LOGOS
import { ReactComponent as AddigyLogo } from "./logos/Addigy.svg";
import { ReactComponent as AkamaiWAFLogo } from "./logos/AkamaiWAF.svg";
import { ReactComponent as AsanaLogo } from "./logos/Asana.svg";
import { ReactComponent as AtlassianLogo } from "./logos/Atlassian.svg";
import { ReactComponent as AWSLogo } from "./logos/aws.svg";
import { ReactComponent as AxurLogo } from "./logos/Axur.svg";
import { ReactComponent as MicrosoftAzureCloudLogo } from "./logos/Azure.svg";
import { ReactComponent as BambooHRLogo } from "./logos/BambooHR.svg";
import { ReactComponent as BitwardenLogo } from "./logos/Bitwarden.svg";
import { ReactComponent as BoxLogo } from "./logos/Box.svg";
import { ReactComponent as BreezeLogo } from "./logos/breeze-48.svg";
import { ReactComponent as CarbonBlackLogo } from "./logos/CarbonBlackCloud.svg";
import { ReactComponent as CatoLogo } from "./logos/Cato.svg";
import { ReactComponent as CheckmarxLogo } from "./logos/Checkmarx.svg";
import { ReactComponent as CheckPointHarmonyLogo } from "./logos/CheckpointHarmony.svg";
import { ReactComponent as CircleCILogo } from "./logos/CircleCI.svg";
import { ReactComponent as ClaudeLogo } from "./logos/Claude.svg";
import { ReactComponent as CloudflareLogo } from "./logos/cloudflare.svg";
import { ReactComponent as CommvaultLogo } from "./logos/Commvault.svg";
import { ReactComponent as CoralogixLogo } from "./logos/Coralogix.svg";
import { ReactComponent as PaloAltoCortexLogo } from "./logos/Cortex.svg";
import { ReactComponent as CrowdStrikeLogo } from "./logos/CrowdStrike.svg";
import { ReactComponent as CursorLogo } from "./logos/Cursor.svg";
import { ReactComponent as CyberArkLogo } from "./logos/CyberArk.svg";
import { ReactComponent as CyeraLogo } from "./logos/Cyera.svg";
import { ReactComponent as DigLogo } from "./logos/Dig.svg";
import { ReactComponent as DocusignLogo } from "./logos/Docusign.svg";
import { ReactComponent as GCPLogo } from "./logos/gcp.svg";
import { ReactComponent as GitHubLogo } from "./logos/github.svg";
import { ReactComponent as GitLabLogo } from "./logos/GitLab.svg";
import { ReactComponent as GoogleLogo } from "./logos/google.svg";
import { ReactComponent as GreenhouseLogo } from "./logos/Greenhouse.svg";
import { ReactComponent as HiBobLogo } from "./logos/HiBob.svg";
import { ReactComponent as HubspotLogo } from "./logos/Hubspot.svg";
import { ReactComponent as ImpervaWAFLogo } from "./logos/ImpervaWAF.svg";
import { ReactComponent as IntuneLogo } from "./logos/Intune.svg";
import { ReactComponent as IruLogo } from "./logos/Iru.svg";
import { ReactComponent as JamfLogo } from "./logos/Jamf.svg";
import { ReactComponent as JamfProtectLogo } from "./logos/JamfProtect.svg";
import { ReactComponent as JiraLogo } from "./logos/Jira.svg";
import { ReactComponent as JumpCloudLogo } from "./logos/jumpcloud.svg";
import { ReactComponent as LayerXLogo } from "./logos/LayerX.svg";
import { ReactComponent as MicrosoftActiveDirectoryLogo } from "./logos/MicrosoftActiveDirectory.svg";
import { ReactComponent as MicrosoftDefenderEndpoint } from "./logos/MicrosoftDefenderEndpoint.svg";
import { ReactComponent as MicrosoftEntraIDLogo } from "./logos/MicrosoftEntraID.svg";
import { ReactComponent as MicrosoftOffice365Logo } from "./logos/MicrosoftOffice365.svg";
import { ReactComponent as MicrosoftSCCMLogo } from "./logos/MicrosoftSCCM.svg";
import { ReactComponent as MicrosoftTeamsLogo } from "./logos/MicrosoftTeams.svg";
import { ReactComponent as MondayLogo } from "./logos/Monday.svg";
import { ReactComponent as MongoAtlasLogo } from "./logos/mongo.svg";
import { ReactComponent as NetskopeLogo } from "./logos/Netskope.svg";
import { ReactComponent as NetsuiteLogo } from "./logos/netsuite.svg";
import { ReactComponent as NinjaOneLogo } from "./logos/NinjaOne.svg";
import { ReactComponent as NotionLogo } from "./logos/Notion.svg";
import { ReactComponent as OktaLogo } from "./logos/Okta.svg";
import { ReactComponent as OneTrustLogo } from "./logos/OneTrust.svg";
import { ReactComponent as OpenAILogo } from "./logos/OpenAI.svg";
import { ReactComponent as OpenVPNLogo } from "./logos/OpenVPN.svg";
import { ReactComponent as OrcaLogo } from "./logos/Orca.svg";
import { ReactComponent as OxLogo } from "./logos/Ox.svg";
import { ReactComponent as PaloAltoPrismaLogo } from "./logos/paloaltoprisma.svg";
import { ReactComponent as PanoraysLogo } from "./logos/Panorays.svg";
import { ReactComponent as PerceptionPointLogo } from "./logos/PerceptionPoint.svg";
import { ReactComponent as PrismaAccessBrowserLogo } from "./logos/prismaAccessBrowser.svg";
import { ReactComponent as ProofpointLogo } from "./logos/Proofpoint.svg";
import { ReactComponent as QualysLogo } from "./logos/Qualys.svg";
import { ReactComponent as Rapid7Logo } from "./logos/Rapid7.svg";
import { ReactComponent as SalesForceLogo } from "./logos/salesforce.svg";
import { ReactComponent as SecurityScorecardLogo } from "./logos/SecurityScorecard.svg";
import { ReactComponent as SentinelOneLogo } from "./logos/SentinelOne.svg";
import { ReactComponent as SentraLogo } from "./logos/Sentra.svg";
import { ReactComponent as ServiceNowLogo } from "./logos/ServiceNow.svg";
import { ReactComponent as SilverfortLogo } from "./logos/Silverfort.svg";
import { ReactComponent as SlackLogo } from "./logos/Slack.svg";
import { ReactComponent as SnowflakeLogo } from "./logos/Snowflake.svg";
import { ReactComponent as SnykLogo } from "./logos/Snyk.svg";
import { ReactComponent as SplunkCloudLogo } from "./logos/SplunkCloud.svg";
import { ReactComponent as StarburstLogo } from "./logos/Starburst.svg";
import { ReactComponent as SumoLogicLogo } from "./logos/SumoLogic.svg";
import { ReactComponent as TenableLogo } from "./logos/Tenable.svg";
import { ReactComponent as TorqLogo } from "./logos/torq.svg";
import { ReactComponent as TwingateLogo } from "./logos/Twingate.svg";
import { ReactComponent as VaronisLogo } from "./logos/Varonis.svg";
import { ReactComponent as VeeamLogo } from "./logos/Veeam.svg";
import { ReactComponent as WizLogo } from "./logos/Wiz.svg";
import { ReactComponent as WorkatoLogo } from "./logos/Workato.svg";
import { ReactComponent as ZendeskLogo } from "./logos/Zendesk.svg";
import { ReactComponent as ZoomLogo } from "./logos/Zoom.svg";
import { ReactComponent as ZscalerLogo } from "./logos/Zscaler.svg";

// COMPONENTS
import { logos } from "../environment/icons/iconExport";
import AddigyIntegration from "./Addigy/Addigy";
import AkamaiWAFIntegration from "./AkamaiWAF/AkamaiWAF";
import Asana from "./Asana/Asana";
import AtlassianIntegration from "./Atlassian/Atlassian";
import AWS from "./AWS/AWS";
import AxurIntegration from "./Axur/Axur";
import BambooHR from "./BambooHR/BambooHR";
import BitwardenIntegration from "./Bitwarden/Bitwarden";
import BoxIntegration from "./Box/Box";
import CarbonBlackIntegration from "./CarbonBlackCloud/CarbonBlackCloud";
import CatoIntegration from "./Cato/Cato";
import CheckmarxIntegration from "./Checkmarx/Checkmarx";
import CheckpointHarmonyBrowseIntegration from "./CheckpointHarmonyBrowse/CheckpointHarmonyBrowse";
import CheckpointHarmonyEndpointIntegration from "./CheckpointHarmonyEndpoint/CheckpointHarmonyEndpoint";
import CircleCIIntegration from "./circleci/CircleCI";
import ClaudeIntegration from "./Claude/Claude";
import CloudConnexaOpenVPNIntegration from "./CloudConnexaOpenVPN/CloudConnexaOpenVPN";
import CloudflareIntegration from "./Cloudflare/Cloudflare";
import ComingSoon from "./components/ComingSoon";
import CoralogixIntegration from "./Coralogix/Coralogix";
import CrowdStrike from "./CrowdStrike/CrowdStrike";
import CursorIntegration from "./Cursor/Cursor";
import CyberArkIdentityIntegration from "./CyberArkIdentity/CyberArkIdentity";
import DigIntegration from "./Dig/Dig";
import GCPIntegration from "./GCP/GCP";
import GitHub from "./GitHub/GitHub";
import GitLabIntegration from "./GitLab/GitLab";
import Google from "./Google/Google";
import Greenhouse from "./Greenhouse/Greenhouse";
import HiBob from "./HiBob/HiBob";
import ImpervaWAFIntegration from "./ImpervaWAF/ImpervaWAF";
import Intune from "./Intune/Intune";
import Jamf from "./Jamf/Jamf";
import JamfProtectIntegration from "./JamfProtect/JamfProtect";
import Jira from "./Jira/Jira";
import JumpCloudIntegration from "./jumpcloud/JumpCloud";
import Kandji from "./Kandji/Kandji";
import LayerXIntegration from "./LayerX/LayerX";
import MicrosoftActiveDirectoryIntegration from "./MicrosoftActiveDirectory/MicrosoftActiveDirectory";
import MicrosoftAzureCloud from "./MicrosoftAzureCloud/MicrosoftAzureCloud";
import MicrosoftDefenderEndpointIntegration from "./MicrosoftDefenderEndpoint/MicrosoftDefenderEndpoint";
import MicrosoftEntraIDIntegration from "./MicrosoftEntraID/MicrosoftEntraID";
import MicrosoftOffice365Integration from "./MicrosoftOffice365/MicrosoftOffice365Integration";
import MicrosoftSCCMIntegration from "./MicrosoftSCCM/MicrosoftSCCM";
import MicrosoftTeams from "./MicrosoftTeams/MicrosoftTeams";
import Monday from "./Monday/Monday";
import MongoAtlasIntegration from "./MongoAtlas/MongoAtlas";
import NetskopeIntegration from "./Netskope/Netskope";
import NinjaOneIntegration from "./NinjaOne/NinjaOne";
import NotionIntegration from "./Notion/Notion";
import OktaIntegration from "./Okta/Okta";
import OneTrustIntegration from "./OneTrust/OneTrust";
import OpenAIIntegration from "./OpenAI/OpenAI";
import OrcaIntegration from "./Orca/Orca";
import OxIntegration from "./Ox/Ox";
import PaloAltoCortexIntegration from "./PaloAltoCortexXDR/PaloAltoCortexXDR";
import PaloAltoCortexXSIAMIntegration from "./PaloAltoCortexXSIAM/PaloAltoCortexXSIAM";
import PaloAltoNGFWIntegration from "./PaloAltoNGFW/PaloAltoNGFW";
import PaloAltoPrismaAccessBrowserIntegration from "./PaloAltoPrismaAccessBrowser/PaloAltoPrismaAccessBrowser";
import PaloAltoTalon from "./PaloAltoTalon/PaloAltoTalon";
import Panorays from "./Panorays/Panorays";
import PerceptionPointIntegration from "./PerceptionPoint/PerceptionPoint";
import Qualys from "./Qualys/Qualys";
import Rapid7Integration from "./Rapid7InsightVM/Rapid7InsightVM";
import SalesforceIntegration from "./Salesforce/Salesforce";
import SecurityScorecard from "./SecurityScorecard/SecurityScorecard";
import SentinelOneIntegration from "./SentinelOne/SentinelOne";
import SentraIntegration from "./Sentra/Sentra";
import ServiceNowIntegration from "./ServiceNow/ServiceNow";
import ServiceNowCMDBIntegration from "./ServiceNowCMDB/ServiceNowCMDB";
import SilverfortIntegration from "./Silverfort/Silverfort";
import SlackIntegration from "./Slack/Slack";
import SlackSaasIntegration from "./SlackSaas/SlackSaas";
import SnowflakeIntegration from "./Snowflake/Snowflake";
import SnykIntegration from "./Snyk/Snyk";
import SplunkCloudIntegration from "./SplunkCloud/SplunkCloud";
import StarburstIntegration from "./Starburst/Starburst";
import SumoLogicIntegration from "./SumoLogic/SumoLogic";
import Tenable from "./Tenable/Tenable";
import TorqIntegration from "./Torq/Torq";
import TwingateIntegration from "./Twingate/Twingate";
import Wiz from "./Wiz/Wiz";
import WorkatoIntegration from "./Workato/Workato";
import ZendeskIntegration from "./Zendesk/Zendesk";
import ZoomIntegration from "./Zoom/Zoom";
import ZscalerZccIntegration from "./ZscalerZcc/ZscalerZcc";
import ZscalerZiaIntegration from "./ZscalerZia/ZscalerZia";
import ZscalerZpaIntegration from "./ZscalerZpa/ZscalerZpa";

export const DEFAULT_INTEGRATION_COLOR = "#BEC7D0";

export const IntegrationCategory = {
  ALERTING: "Alerting and Notification",
  ASPM: "ASPM",
  AUTOMATION: "Automation",
  BACKUP: "Backup & Recovery",
  Collaboration: "Collaboration",
  CRM: "CRM",
  CSP: "Cloud Provider",
  CSPM: "CSPM",
  DB: "Database",
  DLP: "Data Loss Prevention",
  DSPM: "DSPM",
  EDR: "EDR",
  EMAIL: "Email Security",
  ERP: "ERP",
  FW: "FW",
  HR: "HR",
  IAM: "IAM",
  MDM: "MDM",
  SCANNER: "Scanner",
  SIEM: "SIEM",
  TICKETING: "Ticketing",
  TI: "Threat Intelligence",
  TPRM: "Third-Party Risk Management",
  WAF: "WAF",
  ZT: "Zero Trust",
  PASSWORD_MANAGEMENT: "Password Management",
  CONFIGURATION_MANAGEMENT: "Configuration Management",
  AI: "AI",
};

export const IntegrationSegment = {
  APP: "Applications",
  INFRA: "Infrastructure",
  IT: "IT",
  NETWORK: "Network",
};

export const mcpMonitoring = {
  AVAILABLE: "available",
  UPCOMING: "upcoming",
};

export const IntegrationsMapping = {
  // TODO: replace all the old logos with the new ones in another PR https://linear.app/breeze-security/issue/DEV-1852/use-the-newlogo-icons-around-the-platform
  breeze: {
    logo: BreezeLogo,
    displayName: "Breeze Security",
    shortDisplayName: "Breeze",
    codeName: "breeze",
    description: "",
    category: IntegrationCategory.CSPM,
    segment: IntegrationSegment.INFRA,
    component: null,
    available: false,
    configurable: false,
    collectable: true,
    scannable: false,
    hasAdmin: true,
    hasUserLastSeen: true,
    hasVulnerabilityCollection: false,
    newLogo: logos.BreezeLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  crowdstrike: {
    logo: CrowdStrikeLogo,
    displayName: "CrowdStrike Falcon",
    shortDisplayName: "CrowdStrike",
    codeName: "crowdstrike",
    description:
      "CrowdStrike Falcon is a cloud-native endpoint protection platform.",
    category: IntegrationCategory.EDR,
    segment: IntegrationSegment.IT,
    component: <CrowdStrike />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: true,
    hasVulnerabilityCollection: true,
    newLogo: logos.CrowdStrikeLogo,
    // Color is usually set by logo but red is bad (it also rhymes) so changed this one
    integrationColor: "#0343B7",
  },
  jamf: {
    logo: JamfLogo,
    displayName: "Jamf Pro",
    shortDisplayName: "Jamf",
    codeName: "jamf",
    description:
      "Jamf Pro is a comprehensive management system for Apple macOS computers and iOS devices.",
    category: IntegrationCategory.MDM,
    segment: IntegrationSegment.IT,
    component: <Jamf />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    mcpMonitoring: mcpMonitoring.AVAILABLE,
    newLogo: logos.JamfLogo,
    integrationColor: "#118D57",
  },
  jamf_protect: {
    logo: JamfProtectLogo,
    displayName: "Jamf Protect",
    codeName: "jamf_protect",
    description:
      "Jamf Protect is an enterprise macOS security solution using native Apple tools for advanced threat detection and response.",
    category: IntegrationCategory.EDR,
    segment: IntegrationSegment.IT,
    component: <JamfProtectIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.JamfProtectLogo,
    integrationColor: "#24C2CC",
  },
  intune: {
    logo: IntuneLogo,
    displayName: "Microsoft Intune",
    shortDisplayName: "Intune",
    codeName: "intune",
    description:
      "Microsoft Intune is a cloud-based enterprise mobility management (EMM) service.",
    category: IntegrationCategory.MDM,
    segment: IntegrationSegment.IT,
    component: <Intune />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    mcpMonitoring: mcpMonitoring.AVAILABLE,
    newLogo: logos.IntuneLogo,
    integrationColor: "#6E4FEA",
  },
  sentinel_one: {
    logo: SentinelOneLogo,
    displayName: "SentinelOne Singularity",
    shortDisplayName: "SentinelOne",
    codeName: "sentinel_one",
    description:
      "SentinelOne Singularity is a cloud-native endpoint protection platform.",
    category: IntegrationCategory.EDR,
    segment: IntegrationSegment.IT,
    component: <SentinelOneIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.SentinelOneLogo,
    integrationColor: "gray/600-dark",
  },
  microsoft_defender_endpoint: {
    logo: MicrosoftDefenderEndpoint,
    displayName: "Microsoft Defender for Endpoint",
    shortDisplayName: "MDE",
    codeName: "microsoft_defender_endpoint",
    description:
      "Microsoft Defender is a cloud-powered solution that protects against advanced attacks.",
    category: IntegrationCategory.EDR,
    segment: IntegrationSegment.IT,
    component: <MicrosoftDefenderEndpointIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.MicrosoftDefenderEndpoint,
    integrationColor: "#FFB726",
  },
  microsoft_entra_id: {
    logo: MicrosoftEntraIDLogo,
    displayName: "Microsoft Entra ID (Azure AD)",
    shortDisplayName: "Entra ID",
    codeName: "microsoft_entra_id",
    description: "Microsoft Entra ID is an integrated cloud IAM solution.",
    category: IntegrationCategory.IAM,
    segment: IntegrationSegment.INFRA,
    component: <MicrosoftEntraIDIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: true,
    hasVulnerabilityCollection: false,
    newLogo: logos.MicrosoftEntraIDLogo,
    integrationColor: "#6BAAFD",
  },
  microsoft_office_365: {
    logo: MicrosoftOffice365Logo,
    displayName: "Microsoft Office 365",
    shortDisplayName: "Office 365",
    codeName: "microsoft_office_365",
    description: "Microsoft Office 365 is a cloud-based productivity suite.",
    category: IntegrationCategory.Collaboration,
    segment: IntegrationSegment.APP,
    component: <MicrosoftOffice365Integration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.MicrosoftOffice365Logo,
    integrationColor: "#7FCCAD",
  },
  azure: {
    logo: MicrosoftAzureCloudLogo,
    displayName: "Microsoft Azure Cloud",
    shortDisplayName: "Azure",
    codeName: "azure",
    description:
      "Microsoft Azure is a cloud computing platform and service created by Microsoft for building, testing, deploying, and managing applications and services.",
    category: IntegrationCategory.CSP,
    segment: IntegrationSegment.INFRA,
    component: <MicrosoftAzureCloud />,
    available: true,
    configurable: true,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.MicrosoftAzureCloudLogo,
    integrationColor: "#6E4FEA",
  },

  carbonblack: {
    logo: CarbonBlackLogo,
    displayName: "VMware Carbon Black",
    shortDisplayName: "Carbon Black",
    codeName: "carbonblack",
    description: "Carbon Black is a cloud-native endpoint protection platform.",
    category: IntegrationCategory.EDR,
    segment: IntegrationSegment.IT,
    component: <CarbonBlackIntegration />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.CarbonBlackLogo,
    integrationColor: "#FF8A00",
  },
  cyberark_identity: {
    logo: CyberArkLogo,
    displayName: "CyberArk Identity",
    codeName: "cyberark_identity",
    category: IntegrationCategory.IAM,
    segment: IntegrationSegment.IT,
    description:
      "CyberArk Identity is an identity and access management solution that provides secure access to applications and resources.",
    component: <CyberArkIdentityIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.CyberArkLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  checkmarx: {
    logo: CheckmarxLogo,
    displayName: "Checkmarx",
    codeName: "checkmarx",
    category: IntegrationCategory.SCANNER,
    segment: IntegrationSegment.INFRA,
    description:
      "Checkmarx is a security scanning platform. Connect Checkmarx to contextualize vulnerabilities and prioritize remediation.",
    component: <CheckmarxIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.CheckmarxLogo,
    integrationColor: "#54B848",
  },
  paloalto_cortex_xdr: {
    logo: PaloAltoCortexLogo,
    displayName: "Palo Alto Cortex XDR",
    shortDisplayName: "Cortex XDR",
    codeName: "paloalto_cortex_xdr",
    description:
      "Palo Alto Cortex XDR is a cloud-native endpoint protection platform.",
    category: IntegrationCategory.EDR,
    segment: IntegrationSegment.IT,
    component: <PaloAltoCortexIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: true,
    hasVulnerabilityCollection: false,
    newLogo: logos.PaloAltoCortexLogo,
    integrationColor: "#FA582D",
  },
  paloalto_cortex_xsiam: {
    logo: PaloAltoCortexLogo,
    displayName: "Palo Alto Cortex XSIAM",
    codeName: "paloalto_cortex_xsiam",
    category: IntegrationCategory.SIEM,
    segment: IntegrationSegment.APP,
    description:
      "Palo Alto Cortex XSIAM automates security operations with AI-driven threat detection and response.",
    component: <PaloAltoCortexXSIAMIntegration />,
    available: true,
    configurable: true,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.PaloAltoCortexLogo,
    integrationColor: "#BA8045",
  },
  paloalto_ngfw: {
    logo: PaloAltoPrismaLogo,
    displayName: "Palo Alto NGFW",
    shortDisplayName: "Palo Alto",
    codeName: "paloalto_ngfw",
    description:
      "Palo Alto NGFW is a next-generation firewall platform that provides advanced threat protection.",
    category: IntegrationCategory.FW,
    segment: IntegrationSegment.NETWORK,
    component: <PaloAltoNGFWIntegration />,
    available: true,
    configurable: true,
    collectable: false,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.PaloAltoPrismaLogo,
    integrationColor: "#FA582D",
  },
  jira: {
    logo: JiraLogo,
    displayName: "Jira ITSM",
    shortDisplayName: "Jira",
    codeName: "jira",
    category: IntegrationCategory.TICKETING,
    segment: IntegrationSegment.APP,
    description:
      "Jira is a collaboration tool commonly used for issue tracking and project management.",
    component: <Jira />,
    available: true,
    configurable: true,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.JiraLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  atlassian: {
    logo: AtlassianLogo,
    displayName: "Atlassian",
    codeName: "atlassian",
    category: IntegrationCategory.Collaboration,
    segment: IntegrationSegment.APP,
    description:
      "Atlassian is a collaboration tool commonly used for issue tracking and project management.",
    component: <AtlassianIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.AtlassianLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  monday: {
    logo: MondayLogo,
    displayName: "Monday",
    codeName: "monday",
    category: IntegrationCategory.TICKETING,
    segment: IntegrationSegment.APP,
    description:
      "Monday.com is a cloud-based platform for planning, tracking, and managing projects with customizable workflows.",
    component: <Monday />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: true,
    hasVulnerabilityCollection: false,
    newLogo: logos.MondayLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  servicenow: {
    logo: ServiceNowLogo,
    displayName: "ServiceNow ITSM",
    shortDisplayName: "ServiceNow",
    codeName: "servicenow",
    description:
      "ServiceNow provides IT service management (ITSM) solution to streamline business processes.",
    category: IntegrationCategory.TICKETING,
    segment: IntegrationSegment.APP,
    component: <ServiceNowIntegration />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.ServiceNowLogo,
    integrationColor: "#81B5A1",
  },
  servicenow_cmdb: {
    logo: ServiceNowLogo,
    displayName: "ServiceNow CMDB",
    shortDisplayName: "ServiceNow CMDB",
    codeName: "servicenow_cmdb",
    description:
      "ServiceNow CMDB provides configuration management database capabilities for tracking IT assets and infrastructure.",
    category: IntegrationCategory.CONFIGURATION_MANAGEMENT,
    segment: IntegrationSegment.APP,
    component: <ServiceNowCMDBIntegration />,
    available: true,
    configurable: true,
    collectable: true,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.ServiceNowLogo,
    integrationColor: "#81B5A1",
  },
  slack: {
    logo: SlackLogo,
    displayName: "Slack Notifications",
    codeName: "slack",
    category: IntegrationCategory.ALERTING,
    segment: IntegrationSegment.APP,
    description:
      "Slack is a collaboration tool for team communication and collaboration.",
    component: <SlackIntegration />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.SlackLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  slack_saas: {
    logo: SlackLogo,
    displayName: "Slack SaaS",
    codeName: "slack_saas",
    category: IntegrationCategory.Collaboration,
    segment: IntegrationSegment.APP,
    description:
      "Slack is a collaboration tool for team communication and collaboration.",
    component: <SlackSaasIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.SlackLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  qualys: {
    logo: QualysLogo,
    displayName: "Qualys",
    codeName: "qualys",
    category: IntegrationCategory.SCANNER,
    segment: IntegrationSegment.INFRA,
    description:
      "Qualys is a vulnerability scanner. Connect to get visibility into your cloud infrastructure and find misconfigurations.",
    component: <Qualys />,
    available: true,
    configurable: true,
    collectable: true,
    scannable: false,
    hasAdmin: true,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: true,
    newLogo: logos.QualysLogo,
    integrationColor: "#70010E",
  },
  tenable: {
    logo: TenableLogo,
    displayName: "Tenable Nessus",
    shortDisplayName: "Tenable",
    codeName: "tenable",
    category: IntegrationCategory.SCANNER,
    segment: IntegrationSegment.INFRA,
    description:
      "Tenable Nessus is a vulnerability scanner. Connect to get visibility into your cloud infrastructure and find misconfigurations.",
    component: <Tenable />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.TenableLogo,
    integrationColor: "#076537",
  },
  snyk: {
    logo: SnykLogo,
    displayName: "Snyk",
    codeName: "snyk",
    category: IntegrationCategory.SCANNER,
    segment: IntegrationSegment.INFRA,
    description:
      "Snyk is a vulnerability scanner. Connect Snyk to contextualize vulnerabilities and prioritize remediation.",
    component: <SnykIntegration />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.SnykLogo,
    integrationColor: "#C86408",
  },
  okta: {
    logo: OktaLogo,
    displayName: "Okta",
    codeName: "okta",
    category: IntegrationCategory.IAM,
    description:
      "Okta is an IAM management tool. Connect to get visibility into your IAM infrastructure and find misconfigurations.",
    component: <OktaIntegration />,
    available: true,
    configurable: true,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: true,
    segment: IntegrationSegment.INFRA,
    hasVulnerabilityCollection: false,
    newLogo: logos.OktaLogo,
    integrationColor: "#A6FEC4",
  },
  wiz: {
    logo: WizLogo,
    displayName: "Wiz",
    codeName: "wiz",
    category: IntegrationCategory.CSPM,
    segment: IntegrationSegment.INFRA,
    description:
      "Wiz is a cloud security posture management tool. Connect to get visibility into your cloud infrastructure and find misconfigurations.",
    component: <Wiz />,
    available: true,
    configurable: true,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: true,
    newLogo: logos.WizLogo,
    integrationColor: "#008088",
  },
  google: {
    logo: GoogleLogo,
    displayName: "Google Workspace",
    shortDisplayName: "Google",
    codeName: "google",
    description:
      "Google Workspace (G Suite) is a cloud-based productivity suite that helps teams communicate and collaborate.",
    category: IntegrationCategory.Collaboration,
    segment: IntegrationSegment.INFRA,
    component: <Google />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: true,
    hasVulnerabilityCollection: false,
    newLogo: logos.GoogleLogo,
    integrationColor: "#B71D18",
  },
  aws: {
    logo: AWSLogo,
    displayName: "Amazon Web Services",
    shortDisplayName: "AWS",
    codeName: "aws",
    description:
      "Connect to AWS to get visibility into your cloud infrastructure and find misconfigurations.",
    category: IntegrationCategory.CSP,
    segment: IntegrationSegment.INFRA,
    component: <AWS />,
    available: true,
    configurable: true,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.AWSLogo,
    integrationColor: "#61E0E8",
  },
  gcp: {
    logo: GCPLogo,
    displayName: "Google Cloud Platform",
    shortDisplayName: "GCP",
    codeName: "gcp",
    description:
      "Google Cloud Platform (GCP) is a cloud computing suite for infrastructure, AI, analytics, and security.",
    category: IntegrationCategory.CSP,
    segment: IntegrationSegment.INFRA,
    component: <GCPIntegration />,
    available: true,
    configurable: true,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.GCPLogo,
    integrationColor: "#B71D18",
  },
  microsoft_active_directory: {
    logo: MicrosoftActiveDirectoryLogo,
    displayName: "Microsoft Active Directory",
    codeName: "microsoft_active_directory",
    description:
      "Integrate with Active Directory to enrich Breeze with user and resource information.",
    category: IntegrationCategory.IAM,
    segment: IntegrationSegment.IT,
    component: <MicrosoftActiveDirectoryIntegration />,
    available: true,
    configurable: true,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.MicrosoftActiveDirectoryLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  zscaler_zia: {
    logo: ZscalerLogo,
    displayName: "Zscaler ZIA",
    codeName: "zscaler_zia",
    description:
      "Zscaler ZIA is a cloud-native network proxy protection platform.",
    category: IntegrationCategory.EDR,
    segment: IntegrationSegment.NETWORK,
    component: <ZscalerZiaIntegration />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.ZscalerLogo,
    integrationColor: "#FFE49F",
  },
  zscaler_zpa: {
    logo: ZscalerLogo,
    displayName: "Zscaler ZPA",
    codeName: "zscaler_zpa",
    description:
      "Zscaler ZPA is a cloud-native solution enabling direct, secure app access without rerouting traffic.",
    category: IntegrationCategory.ZT,
    segment: IntegrationSegment.NETWORK,
    component: <ZscalerZpaIntegration />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.ZscalerLogo,
    integrationColor: "#FFD6D5",
  },
  zscaler_zcc: {
    logo: ZscalerLogo,
    displayName: "Zscaler ZCC",
    codeName: "zscaler_zcc",
    description:
      "Zscaler Client Connector provides internet traffic protection and policy-based access to internal resources.",
    category: IntegrationCategory.ZT,
    segment: IntegrationSegment.NETWORK,
    component: <ZscalerZccIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.ZscalerLogo,
    integrationColor: "#FFD6D5",
  },
  twingate: {
    logo: TwingateLogo,
    displayName: "Twingate",
    codeName: "twingate",
    description: "Twingate is a modern, zero-trust network access solution.",
    category: IntegrationCategory.ZT,
    segment: IntegrationSegment.NETWORK,
    component: <TwingateIntegration />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.TwingateLogo,
    integrationColor: "#DFD7FF",
  },
  cloudflare: {
    logo: CloudflareLogo,
    displayName: "Cloudflare",
    codeName: "cloudflare",
    description: "Cloudflare is a web infrastructure and security company.",
    category: IntegrationCategory.WAF,
    segment: IntegrationSegment.NETWORK,
    component: <CloudflareIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.CloudflareLogo,
    integrationColor: "#BAA8FF",
  },
  dig: {
    logo: DigLogo,
    displayName: "Dig Security",
    codeName: "dig",
    description:
      "Dig Security is a platform for discovering, monitoring, and securing cloud data assets.",
    category: IntegrationCategory.DSPM,
    segment: IntegrationSegment.INFRA,
    component: <DigIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: false,
    hasAdmin: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.DigLogo,
    integrationColor: "#ACA6FF",
  },
  sentra: {
    logo: SentraLogo,
    displayName: "Sentra",
    codeName: "sentra",
    description:
      "Sentra is a Data Security Posture Management (DSPM) platform that provides comprehensive visibility and security for sensitive data across cloud environments.",
    category: IntegrationCategory.DSPM,
    segment: IntegrationSegment.INFRA,
    component: <SentraIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: false,
    hasAdmin: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.SentraLogo,
    integrationColor: "#6B4EFF",
  },
  ox: {
    logo: OxLogo,
    displayName: "Ox Security",
    codeName: "ox",
    description:
      "Ox Security secures apps by consolidating and prioritizing AppSec risks across the SDLC.",
    category: IntegrationCategory.ASPM,
    segment: IntegrationSegment.INFRA,
    component: <OxIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: false,
    hasAdmin: false,
    hasVulnerabilityCollection: true,
    newLogo: logos.OxLogo,
    integrationColor: "#BCD67F",
  },
  bitwarden: {
    logo: BitwardenLogo,
    displayName: "Bitwarden",
    codeName: "bitwarden",
    description:
      "Bitwarden is a password manager that helps you generate, store, and autofill strong passwords.",
    category: IntegrationCategory.PASSWORD_MANAGEMENT,
    segment: IntegrationSegment.APP,
    component: <BitwardenIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasVulnerabilityCollection: false,
    newLogo: logos.BitwardenLogo,
    integrationColor: "#FCAC7A",
  },

  box: {
    logo: BoxLogo,
    displayName: "Box",
    codeName: "box",
    description:
      "Box is a cloud content management and file sharing service for businesses.",
    category: IntegrationCategory.Collaboration,
    segment: IntegrationSegment.APP,
    component: <BoxIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.BoxLogo,
    integrationColor: "#0061D5",
  },

  salesforce: {
    logo: SalesForceLogo,
    displayName: "Salesforce",
    codeName: "salesforce",
    description: "Salesforce is a cloud-based CRM platform.",
    category: IntegrationCategory.CRM,
    segment: IntegrationSegment.APP,
    component: <SalesforceIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.SalesForceLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  netsuite: {
    logo: NetsuiteLogo,
    displayName: "NetSuite",
    codeName: "netsuite",
    description:
      "NetSuite is a business management platform that integrates ERP, financials, CRM, E-Commerce, and inventory management.",
    category: IntegrationCategory.ERP,
    segment: IntegrationSegment.APP,
    component: <ComingSoon />,
    available: false,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.NetsuiteLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  paloalto_prisma_access: {
    logo: PaloAltoPrismaLogo,
    displayName: "Palo Alto Prisma Access",
    shortDisplayName: "Prisma Access",
    codeName: "paloalto_prisma_access",
    description:
      "Palo Alto Prisma Access is a cloud-delivered security service that provides secure access to applications and data for remote users.",
    category: IntegrationCategory.ZT,
    segment: IntegrationSegment.NETWORK,
    component: <ComingSoon />,
    available: false,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.PaloAltoPrismaLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  mongoatlas: {
    logo: MongoAtlasLogo,
    displayName: "MongoDB Atlas",
    shortDisplayName: "MongoDB",
    codeName: "mongoatlas",
    description:
      "Mongo Atlas is a cloud-based database service for MongoDB. Connect to get visibility into your database infrastructure.",
    category: IntegrationCategory.DB,
    segment: IntegrationSegment.IT,
    component: <MongoAtlasIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: true,
    hasVulnerabilityCollection: false,
    newLogo: logos.MongoAtlasLogo,
    integrationColor: "#4BE098",
  },
  netskope: {
    logo: NetskopeLogo,
    displayName: "Netskope",
    codeName: "netskope",
    description: "Netskope is a cloud, data, and network security platform.",
    category: IntegrationCategory.ZT,
    segment: IntegrationSegment.NETWORK,
    component: <NetskopeIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.NetskopeLogo,
    integrationColor: "#C5DFFF",
  },
  notion: {
    logo: NotionLogo,
    displayName: "Notion",
    shortDisplayName: "Notion",
    codeName: "notion",
    description:
      "Notion is an all-in-one workspace for notes, tasks, wikis, and databases.",
    category: IntegrationCategory.Collaboration,
    segment: IntegrationSegment.APP,
    component: <NotionIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.NotionLogo,
    integrationColor: "#000000",
  },
  github: {
    logo: GitHubLogo,
    displayName: "GitHub",
    codeName: "github",
    segment: IntegrationSegment.INFRA,
    description:
      "GitHub is a platform for hosting and collaborating on software projects using Git.",
    category: IntegrationCategory.Collaboration,
    component: <GitHub />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasVulnerabilityCollection: true,
    newLogo: logos.GitHubLogo,
    integrationColor: "#4D03C5",
  },
  gitlab: {
    logo: GitLabLogo,
    displayName: "GitLab",
    codeName: "gitlab",
    segment: IntegrationSegment.INFRA,
    description:
      "GitLab is a DevOps platform that provides Git repositories, CI/CD, and collaboration tools.",
    category: IntegrationCategory.Collaboration,
    component: <GitLabIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: false,
    hasAdmin: true,
    hasVulnerabilityCollection: false,
    newLogo: logos.GitLabLogo,
    integrationColor: "#FC6D26",
  },
  orca: {
    logo: OrcaLogo,
    displayName: "Orca",
    codeName: "orca",
    description: "Orca is a cloud security posture management tool.",
    category: IntegrationCategory.CSPM,
    segment: IntegrationSegment.INFRA,
    component: <OrcaIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: true,
    newLogo: logos.OrcaLogo,
    integrationColor: "#063281",
  },
  openai: {
    logo: OpenAILogo,
    displayName: "OpenAI",
    codeName: "openai",
    description:
      "OpenAI is a cloud-based AI platform that provides a range of AI services.",
    category: IntegrationCategory.AI,
    segment: IntegrationSegment.APP,
    component: <OpenAIIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: false,
    hasAdmin: true,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.OpenAILogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  torq: {
    logo: TorqLogo,
    displayName: "Torq",
    codeName: "torq",
    description: "Torq is a workflow automation tool.",
    category: IntegrationCategory.AUTOMATION,
    segment: IntegrationSegment.APP,
    component: <TorqIntegration />,
    available: true,
    configurable: true,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.TorqLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  workato: {
    logo: WorkatoLogo,
    displayName: "Workato",
    codeName: "workato",
    description: "Workato is a workflow automation and integration platform.",
    category: IntegrationCategory.AUTOMATION,
    segment: IntegrationSegment.APP,
    component: <WorkatoIntegration />,
    available: true,
    configurable: true,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.WorkatoLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  hibob: {
    logo: HiBobLogo,
    displayName: "HiBob",
    codeName: "hibob",
    description:
      "HiBob is an HR platform for managing employee data, payroll, and performance.",
    category: IntegrationCategory.HR,
    segment: IntegrationSegment.INFRA,
    component: <HiBob />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: true,
    hasVulnerabilityCollection: false,
    newLogo: logos.HiBobLogo,
    integrationColor: "#FFF7A1",
  },
  greenhouse: {
    logo: GreenhouseLogo,
    displayName: "Greenhouse",
    codeName: "greenhouse",
    description:
      "Greenhouse is a hiring software and applicant tracking system.",
    category: IntegrationCategory.HR,
    segment: IntegrationSegment.INFRA,
    component: <Greenhouse />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: true,
    hasVulnerabilityCollection: false,
    newLogo: logos.GreenhouseLogo,
    integrationColor: "#15ae5c",
  },
  snowflake: {
    logo: SnowflakeLogo,
    displayName: "Snowflake",
    codeName: "snowflake",
    description:
      "Snowflake is a cloud data warehouse for storing and analyzing large volumes of data.",
    category: IntegrationCategory.DB,
    segment: IntegrationSegment.IT,
    component: <SnowflakeIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: true,
    hasVulnerabilityCollection: false,
    newLogo: logos.SnowflakeLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  starburst: {
    logo: StarburstLogo,
    displayName: "Starburst",
    codeName: "starburst",
    description:
      "Starburst is a fully-managed, cloud-native data lake analytics platform that provides fast, secure access to data across the enterprise.",
    category: IntegrationCategory.DB,
    segment: IntegrationSegment.IT,
    component: <StarburstIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.StarburstLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  kandji: {
    logo: IruLogo,
    displayName: "Iru (formerly Kandji)",
    codeName: "kandji",
    description:
      "Iru (formerly Kandji) is an Apple device management and security platform.",
    category: IntegrationCategory.MDM,
    segment: IntegrationSegment.IT,
    component: <Kandji />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    mcpMonitoring: mcpMonitoring.AVAILABLE,
    newLogo: logos.IruLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  rapid7_insight_vm: {
    logo: Rapid7Logo,
    displayName: "Rapid7 InsightVM",
    codeName: "rapid7_insight_vm",
    category: IntegrationCategory.SCANNER,
    segment: IntegrationSegment.INFRA,
    description:
      "Rapid7 InsightVM is a vulnerability management tool. Connect to gain visibility into your network and prioritize critical vulnerabilities.",
    component: <Rapid7Integration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: true,
    newLogo: logos.Rapid7Logo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  asana: {
    logo: AsanaLogo,
    displayName: "Asana",
    codeName: "asana",
    category: IntegrationCategory.TICKETING,
    segment: IntegrationSegment.APP,
    description:
      "Asana is a web and mobile application designed to help teams organize, track, and manage their work.",
    component: <Asana />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.AsanaLogo,
    integrationColor: "#FC636B",
  },
  akamai_waf: {
    logo: AkamaiWAFLogo,
    displayName: "Akamai WAF",
    codeName: "akamai_waf",
    category: IntegrationCategory.WAF,
    segment: IntegrationSegment.NETWORK,
    description:
      "Akamai WAF is a a cloud-based solution designed to protect applications and APIs.",
    component: <AkamaiWAFIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.AkamaiWAFLogo,
    integrationColor: "#4094E0",
  },
  securityscorecard: {
    logo: SecurityScorecardLogo,
    displayName: "Security Scorecard",
    codeName: "securityscorecard",
    category: IntegrationCategory.TI,
    segment: IntegrationSegment.NETWORK,
    description:
      "SecurityScorecard is a security rating platform that helps organizations understand and improve their security posture.",
    component: <SecurityScorecard />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.SecurityScorecard,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  panorays: {
    logo: PanoraysLogo,
    displayName: "Panorays",
    codeName: "panorays",
    description:
      "Panorays is a risk management platform that helps organizations manage risks from vendors, suppliers and business partners.",
    category: IntegrationCategory.TPRM,
    segment: IntegrationSegment.INFRA,
    component: <Panorays />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.PanoraysLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  onetrust: {
    logo: OneTrustLogo,
    displayName: "OneTrust",
    codeName: "onetrust",
    description:
      "OneTrust is a privacy, security, and data governance platform for managing compliance, risk, and ethics.",
    category: IntegrationCategory.TPRM,
    segment: IntegrationSegment.INFRA,
    component: <OneTrustIntegration />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.OneTrustLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  perception_point: {
    logo: PerceptionPointLogo,
    displayName: "Perception Point",
    codeName: "perception_point",
    category: IntegrationCategory.EMAIL,
    segment: IntegrationSegment.NETWORK,
    description:
      "Perception Point is a cloud-based solution for advanced threat protection across communications.",
    component: <PerceptionPointIntegration />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.PerceptionPoint,
    integrationColor: "#AFA0D5",
  },
  paloalto_prisma_access_browser: {
    logo: PrismaAccessBrowserLogo,
    displayName: "Palo Alto Prisma Access Browser",
    codeName: "paloalto_prisma_access_browser",
    category: IntegrationCategory.ZT,
    segment: IntegrationSegment.NETWORK,
    description:
      "Cloud-based solution for advanced threat protection across managed and unmanaged devices",
    component: <PaloAltoPrismaAccessBrowserIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.PrismaAccessBrowserLogo,
    integrationColor: "#AFA0D5",
  },
  paloalto_talon: {
    logo: PrismaAccessBrowserLogo,
    displayName: "Palo Alto Talon",
    codeName: "paloalto_talon",
    category: IntegrationCategory.ZT,
    segment: IntegrationSegment.NETWORK,
    description:
      "Cloud-based solution for advanced threat protection across managed and unmanaged devices",
    component: <PaloAltoTalon />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: true,
    hasVulnerabilityCollection: false,
    newLogo: logos.PrismaAccessBrowserLogo,
    integrationColor: "#AFA0D5",
  },
  splunk_cloud: {
    logo: SplunkCloudLogo,
    displayName: "Splunk Cloud",
    codeName: "splunk_cloud",
    description:
      "Splunk Cloud is a cloud-hosted SIEM and data analytics platform that collects, indexes, and analyzes machine data in real-time.",
    category: IntegrationCategory.SIEM,
    segment: IntegrationSegment.APP,
    component: <SplunkCloudIntegration />,
    available: true,
    configurable: true,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.SplunkCloudLogo,
    integrationColor: "#008000",
  },
  sumologic: {
    logo: SumoLogicLogo,
    displayName: "Sumo Logic",
    codeName: "sumologic",
    description:
      "Sumo Logic is a cloud-native SIEM and log management platform for real-time analytics.",
    category: IntegrationCategory.SIEM,
    segment: IntegrationSegment.APP,
    component: <SumoLogicIntegration />,
    available: true,
    configurable: true,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.SumoLogicLogo,
    integrationColor: "#00CCBB",
  },
  bamboohr: {
    logo: BambooHRLogo,
    displayName: "BambooHR",
    codeName: "bamboohr",
    description:
      "BambooHR is an HR software for small and medium-sized businesses.",
    category: IntegrationCategory.HR,
    segment: IntegrationSegment.INFRA,
    component: <BambooHR />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.BambooHRLogo,
    integrationColor: "#007000",
  },
  proofpoint: {
    logo: ProofpointLogo,
    displayName: "Proofpoint",
    codeName: "proofpoint",
    description:
      "Proofpoint is an enterprise security solution that provides protection against email threats, social media threats, and more.",
    category: IntegrationCategory.EMAIL,
    segment: IntegrationSegment.NETWORK,
    component: <ComingSoon />,
    available: false,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.ProofpointLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  axur: {
    logo: AxurLogo,
    displayName: "Axur",
    codeName: "axur",
    description:
      "Axur is a digital risk protection platform that helps organizations monitor and protect their online presence.",
    category: IntegrationCategory.TI,
    segment: IntegrationSegment.NETWORK,
    component: <AxurIntegration />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.AxurLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  checkpoint_harmony_browse: {
    logo: CheckPointHarmonyLogo,
    displayName: "Check Point Harmony Browse",
    codeName: "checkpoint_harmony_browse",
    description:
      "Cloud-based solution for advanced threat protection when browsing the Internet from managed and unmanaged devices.",
    category: IntegrationCategory.ZT,
    segment: IntegrationSegment.INFRA,
    component: <CheckpointHarmonyBrowseIntegration />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.CheckpointHarmonyLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  checkpoint_harmony_endpoint: {
    logo: CheckPointHarmonyLogo,
    displayName: "Check Point Harmony Endpoint",
    codeName: "checkpoint_harmony_endpoint",
    description:
      "Cloud-based endpoint security solution that provides advanced threat prevention and detection across all endpoints.",
    category: IntegrationCategory.ZT,
    segment: IntegrationSegment.INFRA,
    component: <CheckpointHarmonyEndpointIntegration />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.CheckpointHarmonyLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  circleci: {
    logo: CircleCILogo,
    displayName: "CircleCI",
    shortDisplayName: "CircleCI",
    codeName: "circleci",
    description:
      "CircleCI is a continuous integration and continuous deployment (CI/CD) platform that helps teams build, test, and deploy applications quickly and efficiently.",
    category: IntegrationCategory.Collaboration,
    segment: IntegrationSegment.INFRA,
    component: <CircleCIIntegration />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.CircleCILogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  veeam: {
    logo: VeeamLogo,
    displayName: "Veeam",
    codeName: "veeam",
    description:
      "Veeam is a data protection and recovery solution for virtual, physical, and cloud-based workloads.",
    category: IntegrationCategory.BACKUP,
    segment: IntegrationSegment.IT,
    component: <ComingSoon />,
    available: false,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.VeeamLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  commvault: {
    logo: CommvaultLogo,
    displayName: "Commvault",
    codeName: "commvault",
    description:
      "Commvault is an enterprise data protection and management platform offering backup, recovery, and cloud services.",
    category: IntegrationCategory.BACKUP,
    segment: IntegrationSegment.IT,
    component: <ComingSoon />,
    available: false,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.CommvaultLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  varonis: {
    logo: VaronisLogo,
    displayName: "Varonis",
    codeName: "varonis",
    description:
      "Varonis is a data security platform that protects enterprise data from insider threats and cyberattacks.",
    category: IntegrationCategory.DLP,
    segment: IntegrationSegment.IT,
    component: <ComingSoon />,
    available: false,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.VaronisLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  cyera: {
    logo: CyeraLogo,
    displayName: "Cyera",
    codeName: "cyera",
    description:
      "Data security platform that helps organizations discover, classify, and protect sensitive data across cloud environments.",
    category: IntegrationCategory.DSPM,
    segment: IntegrationSegment.IT,
    component: <ComingSoon />,
    available: false,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.CyeraLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  zoom: {
    logo: ZoomLogo,
    displayName: "Zoom",
    codeName: "zoom",
    description:
      "Zoom is a cloud-based video communications platform for virtual meetings, webinars, and collaboration.",
    category: IntegrationCategory.Collaboration,
    segment: IntegrationSegment.APP,
    component: <ZoomIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: true,
    hasVulnerabilityCollection: false,
    newLogo: logos.ZoomLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  docusign: {
    logo: DocusignLogo,
    displayName: "Docusign",
    codeName: "docusign",
    description:
      "Docusign enables organizations to manage electronic agreements securely and efficiently.",
    category: IntegrationCategory.Collaboration,
    segment: IntegrationSegment.APP,
    component: <ComingSoon />,
    available: false,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.DocusignLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  hubspot: {
    logo: HubspotLogo,
    displayName: "HubSpot",
    codeName: "hubspot",
    description:
      "HubSpot is a CRM platform with marketing, sales, content management, and customer service capabilities.",
    category: IntegrationCategory.CRM,
    segment: IntegrationSegment.APP,
    component: <ComingSoon />,
    available: false,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.HubspotLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  microsoft_teams: {
    logo: MicrosoftTeamsLogo,
    displayName: "Microsoft Teams Notifications",
    shortDisplayName: "Teams",
    codeName: "microsoft_teams",
    description:
      "Microsoft Teams is a collaboration platform for team communication and notifications.",
    category: IntegrationCategory.ALERTING,
    segment: IntegrationSegment.APP,
    component: <MicrosoftTeams />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.MicrosoftTeamsLogo,
    integrationColor: "#6264A7",
  },
  jumpcloud: {
    logo: JumpCloudLogo,
    displayName: "JumpCloud",
    codeName: "jumpcloud",
    description:
      "JumpCloud is a cloud directory platform for managing identities, devices, and access.",
    category: IntegrationCategory.MDM,
    segment: IntegrationSegment.IT,
    component: <JumpCloudIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.JumpCloudLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  ninjaone: {
    logo: NinjaOneLogo,
    displayName: "NinjaOne",
    codeName: "ninjaone",
    description:
      "NinjaOne is an IT platform for remotely managing, monitoring, and supporting devices.",
    category: IntegrationCategory.MDM,
    segment: IntegrationSegment.IT,
    component: <NinjaOneIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: true,
    hasVulnerabilityCollection: false,
    newLogo: logos.NinjaOneLogo,
    integrationColor: "#053856",
  },
  zendesk: {
    logo: ZendeskLogo,
    displayName: "Zendesk",
    shortDisplayName: "Zendesk",
    codeName: "zendesk",
    description:
      "Zendesk is a customer service platform that provides help desk ticketing, support, and customer engagement tools.",
    category: IntegrationCategory.Collaboration,
    segment: IntegrationSegment.APP,
    component: <ZendeskIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: true,
    hasVulnerabilityCollection: false,
    newLogo: logos.ZendeskLogo,
    integrationColor: "#03363D",
  },
  layerx: {
    logo: LayerXLogo,
    displayName: "LayerX",
    shortDisplayName: "LayerX",
    codeName: "layerx",
    description:
      "LayerX Security provides protection for enterprise applications, data, and devices from web-borne threats and browsing risks.",
    category: IntegrationCategory.ZT,
    segment: IntegrationSegment.IT,
    component: <LayerXIntegration />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.LayerXLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  cloudconnexa_open_vpn: {
    logo: OpenVPNLogo,
    displayName: "CloudConnexa Open VPN",
    shortDisplayName: "CloudConnexa Open VPN",
    codeName: "cloudconnexa_open_vpn",
    description:
      "CloudConnexa is a cloud-based VPN and secure networking service by OpenVPN.",
    category: IntegrationCategory.ZT,
    segment: IntegrationSegment.NETWORK,
    component: <CloudConnexaOpenVPNIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.OpenVPNLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  addigy: {
    logo: AddigyLogo,
    displayName: "Addigy",
    shortDisplayName: "Addigy",
    codeName: "addigy",
    description:
      "Addigy is a cloud-based Apple device management platform that lets IT teams and MSPs deploy, configure, monitor, and support macOS, iOS, iPadOS and tvOS devices at scale.",
    category: IntegrationCategory.MDM,
    segment: IntegrationSegment.IT,
    component: <AddigyIntegration />,
    available: true,
    configurable: true,
    collectable: true,
    scannable: false,
    hasAdmin: true,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.AddigyLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  cato: {
    logo: CatoLogo,
    displayName: "Cato",
    shortDisplayName: "Cato",
    codeName: "cato",
    description:
      "Cato is a cloud-based network security platform that provides visibility and control over network traffic.",
    category: IntegrationCategory.ZT,
    segment: IntegrationSegment.NETWORK,
    component: <CatoIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: true,
    hasVulnerabilityCollection: false,
    newLogo: logos.CatoLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  microsoft_sccm: {
    logo: MicrosoftSCCMLogo,
    displayName: "Microsoft SCCM",
    shortDisplayName: "Microsoft SCCM",
    codeName: "microsoft_sccm",
    description:
      "Microsoft SCCM is a system management solution for managing Windows devices.",
    category: IntegrationCategory.MDM,
    segment: IntegrationSegment.IT,
    component: <MicrosoftSCCMIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.MicrosoftSCCMLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  silverfort: {
    logo: SilverfortLogo,
    displayName: "Silverfort",
    shortDisplayName: "Silverfort",
    codeName: "silverfort",
    description:
      "Silverfort is a unified identity protection platform that provides agentless authentication security for hybrid and multi-cloud environments.",
    category: IntegrationCategory.IAM,
    segment: IntegrationSegment.IT,
    component: <SilverfortIntegration />,
    available: true,
    configurable: false,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.SilverfortLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  coralogix: {
    logo: CoralogixLogo,
    displayName: "Coralogix",
    codeName: "coralogix",
    description: "Coralogix is a cloud-based logging and monitoring platform.",
    category: IntegrationCategory.SIEM,
    segment: IntegrationSegment.APP,
    component: <CoralogixIntegration />,
    available: true,
    configurable: true,
    collectable: false,
    scannable: false,
    hasAdmin: false,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.CoralogixLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  claude: {
    logo: ClaudeLogo,
    displayName: "Claude",
    codeName: "claude",
    description:
      "Claude is Anthropic's AI assistant that provides conversational AI capabilities.",
    category: IntegrationCategory.AI,
    segment: IntegrationSegment.APP,
    component: <ClaudeIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: false,
    hasAdmin: true,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.ClaudeLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  cursor: {
    logo: CursorLogo,
    displayName: "Cursor",
    codeName: "cursor",
    description:
      "Cursor is an AI-powered code editor for individuals and teams.",
    category: IntegrationCategory.AI,
    segment: IntegrationSegment.APP,
    component: <CursorIntegration />,
    available: true,
    configurable: true,
    collectable: true,
    scannable: false,
    hasAdmin: true,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.CursorLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
  imperva_waf: {
    logo: ImpervaWAFLogo,
    displayName: "Imperva WAF",
    codeName: "imperva_waf",
    description:
      "Imperva WAF is a web application firewall that protects applications from web-based attacks.",
    category: IntegrationCategory.WAF,
    segment: IntegrationSegment.NETWORK,
    component: <ImpervaWAFIntegration />,
    available: true,
    configurable: false,
    collectable: true,
    scannable: true,
    hasAdmin: true,
    hasUserLastSeen: false,
    hasVulnerabilityCollection: false,
    newLogo: logos.ImpervaWAFLogo,
    integrationColor: DEFAULT_INTEGRATION_COLOR,
  },
};
